export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q05_a.246ec12f.png";